export default {
  tooltip: {
    balance: "My Wallet Balance",
    limitSwitch: "A brief explanation of this section will be displayed here."
  },
  categoriesMenu: ["Cheapest", "Most Expensive"],
  pricesTable: {
    title: "Real-time Cryptocurrency Prices",
    subtitle: "Currency Prices",
    noData: "No cryptocurrencies found",
    latestUpdate: {
      label: "Last Update: ",
      time: "minutes ago"
    },
    tableTabs: [
      {
        title: "Favorites",
        id: 3
      },
      {
        title: "Assets",
        id: 2
      },
      {
        title: "Currencies",
        id: 1
      }
    ],
    tableHeader: [
      {
        text: "Symbol",
        align: "start",
        sortable: true,
        value: "symbol",
        width: 100
      },
      {
        text: "Price",
        value: "sell_rate_price",
        align: "start",
        sortable: true
      },
      {
        text: "Changes",
        value: "daily_change_percent",
        align: "start",
        sortable: true
      }
    ],
    baseCurrencyPrice: "Price ({iso})",
    searchInputPlaceholder: "Search"
  },
  orderCard: {
    bitcoin: "Bitcoin"
  },
  orderForm: {
    amountInput: "Amount",
    outcome: "Total",
    income: "Total",
    price: "Price",
    orderLimit: ["Amount", "Percentage"],
    priceReached: "When the price reaches",
    tooltipDesc:
      "In this section, you can specify when the price of the desired cryptocurrency reaches the set price, a buy or sell will be executed for you.",
    orderValidityPeriod: "Order Validity Period",
    minutes: "Minutes",
    hours: "Hours",
    wage: "Fee",
    received: "Received",
    sell: "Sell",
    buy: "Buy",
    minAmountRules: "You cannot enter less than {assetMin} {iso}",
    maxAmountRules: "You cannot enter more than {assetMax} {iso}",
    minPriceRules: "You cannot enter less than {baseMin} {iso}",
    maxPriceRules: "You cannot enter more than {baseMax} {iso}",
    minOrderRules: "You cannot set a price less than {minMask} {iso}",
    maxOrderRules: "You cannot set a price more than {maxMask} {iso}",
    minOrderPercentRules: "The minimum amount entered can be -%{percent}",
    maxZeroOrderPercentRules: "The maximum amount entered can be %0",
    minZeroOrderPercentRules: "The minimum amount entered can be %0",
    maxOrderPercentRules: "The maximum amount entered can be %{percent}",
    maxMinute: "{maxMinute} minutes",
    maxHour: "{maxHour} hours",
    and: "and",
    timeRules: "You cannot set more than {minuteRule} {andRule} {hourRule}",
    specifyOrderTime: "Please specify your order validity time",
    orderTimeItems: [
      {
        value: "0",
        text: "Less than 1 hour"
      },
      {
        value: "3",
        text: "3 hours"
      },
      {
        value: "5",
        text: "5 hours"
      },
      {
        value: "8",
        text: "8 hours"
      }
    ]
  },
  tradingView: {
    title: "Global Cryptocurrency Price Chart",
    description:
      "This chart is not based on Excoino prices and is just for viewing global cryptocurrency price trends.",
    filters: [
      {
        title: "Hourly",
        value: "hourly",
        tabIndex: 0
      },
      {
        title: "Daily",
        value: "daily",
        tabIndex: 0
      },
      {
        title: "Weekly",
        value: "weekly",
        tabIndex: 1
      },
      {
        title: "Monthly",
        value: "monthly",
        tabIndex: 2
      }
    ]
  },
  orderList: {
    viewAllOrders: "View All Orders",
    tabs: [
      {
        faTitle: "All Orders",
        enTitle: ""
      },
      {
        faTitle: "Open Orders",
        enTitle: "PROCESSING"
      },
      {
        faTitle: "Completed",
        enTitle: "DONE"
      },
      {
        faTitle: "Expired",
        enTitle: "EXPIRED"
      },
      {
        faTitle: "Canceled",
        enTitle: "CANCELED"
      },
      {
        faTitle: "Rejected",
        enTitle: "FAILED"
      }
    ],
    dataTable: {
      typeOfOrder: {
        buy: "Buy",
        sell: "Sell"
      },
      cancelOrder: "Cancel",
      noData: "You have no registered orders."
    },
    dataTableHeader: [
      {
        text: "Order ID",
        align: "left",
        sortable: false,
        value: "reference_number"
      },
      {
        text: "Type",
        align: "center",
        sortable: false,
        value: "direction"
      },
      {
        text: "Currency Name",
        align: "center",
        sortable: false,
        value: "asset_currency_iso"
      },
      {
        text: "Amount",
        align: "left",
        sortable: false,
        value: "asset_amount"
      },
      {
        text: "Base",
        align: "center",
        sortable: false,
        value: "base_currency_iso"
      },
      {
        text: "Price",
        align: "left",
        sortable: false,
        value: "base_amount"
      },
      {
        text: "Total",
        align: "left",
        sortable: false,
        value: "total_amount"
      },
      {
        text: "Net Received",
        align: "left",
        sortable: false,
        value: "pure_amount"
      },
      {
        text: "Expiration",
        align: "center",
        sortable: false,
        value: "expires_at",
        width: 150
      },
      {
        text: "Status",
        align: "left",
        sortable: false,
        value: "status_locale",
        width: 150
      },
      {
        text: "Registration Time",
        align: "center",
        sortable: false,
        value: "date",
        width: 150
      },
      {
        text: "Actions",
        align: "center",
        sortable: false,
        value: "actions",
        width: 100
      }
    ],
    dataTableHeaderWithoutOperation: [
      {
        text: "Order ID",
        align: "left",
        sortable: false,
        value: "reference_number"
      },
      {
        text: "Type",
        align: "center",
        sortable: false,
        value: "direction"
      },
      {
        text: "Currency Name",
        align: "center",
        sortable: false,
        value: "asset_currency_iso"
      },
      {
        text: "Amount",
        align: "left",
        sortable: false,
        value: "asset_amount"
      },
      {
        text: "Base",
        align: "center",
        sortable: false,
        value: "base_currency_iso"
      },
      {
        text: "Price",
        align: "left",
        sortable: false,
        value: "base_amount"
      },
      {
        text: "Total",
        align: "left",
        sortable: false,
        value: "total_amount"
      },
      {
        text: "Net Received",
        align: "left",
        sortable: false,
        value: "pure_amount"
      },
      {
        text: "Expiration",
        align: "center",
        sortable: false,
        value: "expires_at",
        width: 150
      },
      {
        text: "Status",
        align: "left",
        sortable: false,
        value: "status_locale",
        width: 150
      },
      {
        text: "Registration Time",
        align: "center",
        sortable: false,
        value: "date",
        width: 150
      }
    ],
    modal: {
      ordersHistory: "Order History"
    }
  },
  orderInvoiceCard: {
    title: "Order Confirmation",
    currencyType: "Currency Type",
    currencyBase: "Base",
    currencyAmount: "Amount",
    currencyPrice: "Price",
    currencyTotalAmount: "Total",
    orderExpiredTime: {
      title: "Order Validity Period",
      hour: "Hour",
      minute: "Minute"
    },
    currencyFee: "Fee",
    currencyPureAmount: "Net Received",
    buyOrder: "Confirm Order and Buy",
    sellOrder: "Confirm Order and Sell"
  },
  orderNotificationCard: {
    title: "Insufficient Balance",
    description:
      "Your wallet balance is insufficient. Please increase your balance and place the order again.",
    cancelBtn: "Cancel",
    confirmBtn: "Increase Balance"
  },
  exchangeAutoComplete: {
    inputPlaceholder: "Search by currency name or symbol...",
    noResults: "No results found.",
    noData: "No results found."
  },
  numberInput: {
    allAssetsButton: "All"
  }
};
